function encodePathSegment(value: number | string): string {
  return encodeURIComponent(String(value));
}

function appendTemplateVersion(path: string): string {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}v=${encodeURIComponent(
    SHARE_CARD_TEMPLATE_VERSION,
  )}`;
}

export const SHARE_CARD_API_ROUTE_VERSION = "v1";
export const SHARE_CARD_TEMPLATE_VERSION = "v1";

export function buildArticleShareCardPath(articleId: number | string): string {
  return `/api/share-cards/${SHARE_CARD_API_ROUTE_VERSION}/articles/${encodePathSegment(
    articleId,
  )}.png`;
}

export function buildArticleShareCardDownloadUrl(
  articleId: number | string,
): string {
  return appendTemplateVersion(buildArticleShareCardPath(articleId));
}
